export const crispChatConfig = `window.$crisp = [];
window.CRISP_WEBSITE_ID = "fdd15fa8-a953-44a9-ad7b-3a2bd799b432";
(function () {
  d = document;
  s = d.createElement("script");
  s.src = "https://client.crisp.chat/l.js";
  s.async = 1;
  d.getElementsByTagName("head")[0].appendChild(s);
})();
`;
